var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card-caption",class:{
    'card-caption--disabled': _vm.disabled,
    'card-caption--no-section': _vm.hasNoSection,
    'card-caption--unclickable': _vm.unClickable,
  }},[_c('small',{staticClass:"card-caption__cap caption",class:{ 'card-caption__float': _vm.capFloat }},[_vm._t("caption")],2),_c('header',{staticClass:"card-caption__header"},[_vm._t("header")],2),_c('section',{staticClass:"card-caption__section"},[_vm._t("section")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }